/**
 * Fetches the product recommendations section HTML (see Shopify Ajax API:
 * GET /{locale}/recommendations/products?product_id=&section_id=&limit=&intent=)
 * removes skeleton placeholders, then appends the fetched list items to the existing ul.
 */
if (typeof ProductRecommendations === "undefined") {
	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();
			this.isLoaded = false;
		}

		connectedCallback() {
			if (this.isLoaded) return;
			this.isLoaded = true;

			const url = this.dataset.url;
			if (!url) return;

			fetch(url)
				.then((response) => {
					if (!response.ok) throw new Error(`HTTP ${response.status}`);
					return response.text();
				})
				.then((text) => {
					const wrapper = document.createElement("div");
					wrapper.innerHTML = text;
					const next = wrapper.querySelector("ul");
					console.log("RECS", next);

					if (next && next.innerHTML.trim().length) {
						const ul = this.querySelector("ul");
						if (!ul) return;

						ul.querySelectorAll(".skeleton-list-item").forEach((el) => el.remove());

						const fragment = document.createDocumentFragment();
						next.querySelectorAll(":scope > li").forEach((li) => {
							fragment.appendChild(li);
						});
						ul.appendChild(fragment);
					}
				})
				.catch((e) => {
					console.error("Error fetching product recommendations:", e);
				});
		}
	}

	if (!window.customElements.get("product-recommendations")) {
		window.customElements.define("product-recommendations", ProductRecommendations);
	}
}
